module.exports = __webpack_public_path__ + "img/book3.d9d4aff0.png";